import React from 'react';
import '../../../assets/css/HeroSection.css';
import uthramenon from "../../../assets/images/uhtarmenon.png"

const HeroSection = () => {
  return (
    <div className="hero-container">
      <nav className="hero-nav">
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#brands">Brands</a>
        <a href="#contact">Contact Us</a>
      </nav>
      <div className="hero-content">
        <img 
          src={uthramenon} 
          alt="Uthara Menon" 
          className="hero-title-image"
        />
      </div>
    </div>
  );
};

export default HeroSection;
